import React, { useEffect } from "react";
import '../../Styles/about.css';
import AOS from "aos";
import "aos/dist/aos.css";
import WOW from 'wowjs';
import profile from '../../Assets/PROFILE.jpg';
import { GitHub } from "@mui/icons-material";

const About = () => {
  useEffect(() => {
    AOS.init();
  }, []);
  return (
    <div className="page-container">
      <div className="page-title">
        <h1 data-aos="fade-up">ABOUT</h1>
      </div>
      <div className="page-div">
        <div id='profiletxt' data-aos="fade-up">
          <h1>프론트엔드 개발자를 꿈꾸는 홍세현 입니다.</h1>
          <p>
            <span>새로운 도전</span>을 두려워하지 않고, <span>끊임없이 학습</span>하며 성장하는 것을 즐깁니다. <br/>
            함께 성장하는 기회를 기다리고 있습니다.
          </p>       
          <p>
            교육 : <span>부산대학교 SW개발자 양성과정 수료 </span> (2023.04.03 ~ 2023.09.22)
          </p>  
          </div>
        <div id="profile-content" >
          <div id="profileimg" data-aos="flip-left">
            <img src={profile} alt="profile image" />
          </div>
          <div id="profile-url" data-aos="flip-left">
            <a href="mailto:sese0733@naver.com">
              <button className="profile-bt">sese0733@naver.com</button>
            </a>
            <a href="https://github.com/hong-sehyun">
              <button className="profile-bt">GITHUB</button>
            </a>
            <a href="https://bitter-crane-65f.notion.site/K-e92b55d2ff8e456aad42df11d3f1b9ea?pvs=4">
              <button className="profile-bt">NOTION</button>
            </a>
          </div>
        </div>
      </div>
    </div >
  )
}

export default About